const tipoSolicitacaoArquivoList = [
   {
      id: 10,
      descricao: 'Declaração do Imposto de Renda',
      observacaoSolicitacaoArquivo: 'Última declaração entregue',
      ordem: 10,
   },
   {
      id: 20,
      descricao: 'Apólices de Seguro de Vida',
      observacaoSolicitacaoArquivo: '',
      ordem: 20,
   },
   {
      id: 30,
      descricao: 'Posições de Investimentos',
      observacaoSolicitacaoArquivo: 'Extratos das posições dos investimentos nas corretoras e/ou bancos',
      ordem: 30,
   },
   {
      id: 40,
      descricao: 'Extratos da Previdência Privada',
      observacaoSolicitacaoArquivo: 'Extratos da previdência privada nas corretoras e/ou bancos e/ou seguradoras',
      ordem: 40,
   },
   {
      id: 50,
      descricao: 'Extratos das Contas Bancárias',
      observacaoSolicitacaoArquivo: 'Últimos 2 meses',
      ordem: 50,
   },
   {
      id: 60,
      descricao: 'Extratos dos Cartões de Crédito',
      observacaoSolicitacaoArquivo: 'Últimos 2 meses',
      ordem: 60,
   },
   {
      id: 70,
      descricao: 'Controle Orçamentário',
      observacaoSolicitacaoArquivo: 'Planilha de controle orçamentário',
      ordem: 70,
   },
   {
      id: 80,
      descricao: 'Carterinhas do Plano de Saúde',
      observacaoSolicitacaoArquivo: '',
      ordem: 80,
   },
   {
      id: 210,
      descricao: 'Extratos de Dívidas',
      observacaoSolicitacaoArquivo: 'Extratos de dívidas atualizadas',
      ordem: 210,
   },
   {
      id: 220,
      descricao: 'Dívidas e Pendências Fiscais',
      observacaoSolicitacaoArquivo: 'Consultar pelo CPF: https://www.gov.br/pt-br/servicos/consultar-dividas-e-pendencias-fiscais',
      ordem: 220,
   },
   {
      id: 230,
      descricao: 'Score no Serasa ',
      observacaoSolicitacaoArquivo: 'Consultar o score e pendências utilizando o acesso gratuito pelo CPF: https://www.serasa.com.br/entrar',
      ordem: 230,
   },
]
  
export default tipoSolicitacaoArquivoList